<template>
  <div
    :id="`auto-${id}`"
    class="text-input"
    :class="{ accepted: accepted, error: error, hasValue: hasValue }"
  >
    <span class="label">{{ placeholder }}</span>
    <div class="input-field">
      <input
        type="text"
        :value="modelValue"
        @input="updateValue"
        @blur="inputBlur"
        @keydown.down="focusSuggestionsFirst"
        @keydown.up="focusSuggestionsLast"
      />
      <fa
        icon="check"
        class="checkmark"
      />
      <fa
        icon="exclamation"
        class="exclamation"
      />
    </div>
    <ul
      v-if="this.modelValue == this.options.find((option) => option == this.modelValue)"
    ></ul>
    <ul
      class="suggestion-box"
      v-else-if="optionsComputed == 0"
    >
      <li>
        <fa
          icon="circle-notch"
          class="loading-spin"
          spin
        />
        Adressvorschläge werden geladen
      </li>
    </ul>
    <ul
      class="suggestion-box"
      v-else
    >
      <li
        class="suggestion-item"
        v-for="option in optionsComputed"
        :key="option"
        @click="chooseOption(option)"
        @keyup.enter="chooseOption(option)"
        @keydown.down="suggestionsDown"
        @keydown.up="suggestionsUp"
        :tabindex="0"
      >
        {{ option }}
      </li>
    </ul>
    <small class="error-msg">{{ errorMsg }}</small>
  </div>
</template>
<script>
export default {
  name: "text-field-autocomplete",
  props: {
    modelValue: String,
    placeholder: String,
    state: String,
    options: Array,
    id: String,
  },
  computed: {
    accepted() {
      return this.state && this.state.startsWith("ACCEPTED");
    },
    error() {
      return this.state && this.state.startsWith("ERROR");
    },
    errorMsg() {
      return this.error && this.state.split("ERROR").pop();
    },
    hasValue() {
      return this.modelValue != null && this.modelValue.length > 0;
    },
    optionsComputed() {
      if (
        // !this.modelValue ||
        // this.modelValue.length <= 0 ||
        this.options.includes(this.modelValue)
      ) {
        return [];
      }
      return this.options.filter((option) => {
        const optionLowercase = option.toLowerCase();
        if(this.modelValue) {
          return optionLowercase.includes(this.modelValue.toLowerCase());
        }
        else {
          return optionLowercase;
        }
      });
    },
  },
  methods: {
    updateValue(event) {
      this.$emit("update:modelValue", event.target.value);
      this.$emit("inputChanged", event.target.value);
    },
    chooseOption(option) {
      this.$emit("update:modelValue", option);
      this.$emit("valueSet");
    },
    inputBlur(event) {
      if (
        !(
          event.relatedTarget &&
          event.relatedTarget.className.includes("text-input")
        )
      ) {
        this.$emit("valueSet");
      }
    },
    focusSuggestionsFirst(e) {
      e.preventDefault();
      const suggestions = document
        .getElementById(`auto-${this.id}`)
        .getElementsByClassName("suggestion-item");
      if (suggestions && suggestions.length > 0) {
        suggestions[0].focus();
      }
    },
    focusSuggestionsLast(e) {
      e.preventDefault();
      const suggestions = document
        .getElementById(`auto-${this.id}`)
        .getElementsByClassName("suggestion-item");
      if (suggestions && suggestions.length > 0) {
        suggestions[suggestions.length - 1].focus();
      }
    },
    suggestionsDown(e) {
      e.preventDefault();
      if (e.target.nextElementSibling?.classList.contains("suggestion-item")) {
        e.target.nextElementSibling?.focus();
      } else {
        const suggestions = document
          .getElementById(`auto-${this.id}`)
          .getElementsByClassName("suggestion-item");
        if (suggestions && suggestions.length > 0) {
          suggestions[0].focus();
        }
      }
    },
    suggestionsUp(e) {
      e.preventDefault();
      if (
        e.target.previousElementSibling?.classList.contains("suggestion-item")
      ) {
        e.target.previousElementSibling?.focus();
      } else {
        const suggestions = document
          .getElementById(`auto-${this.id}`)
          .getElementsByClassName("suggestion-item");
        if (suggestions && suggestions.length > 0) {
          suggestions[suggestions.length - 1].focus();
        }
      }
    },
  },
};
</script>
